import styled from 'styled-components';
import { Form as Unform } from '@unform/web';

export const Container = styled.div`
  background: var(--background-color);
  padding: 20px;
  box-shadow: var(--box-shadow);
`;

export const Title = styled.h1`
  color: var(--color);
  font-family: 'GothamBold', Arial, Helvetica, sans-serif;
  font-size: 3.2rem;
`;

export const Form = styled(Unform)`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  & > div {
    align-self: start;
  }

  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  gap: 10px;
`;
